import { useEffect, useState, type CSSProperties, type ReactNode } from 'react'
import { resolveProfilePictureUrl } from '../lib/profilePictureUrlResolver'

type Props = {
  rawUrl?: string | null
  alt: string
  className?: string
  style?: CSSProperties
  fallback?: ReactNode
}

export function SignedProfileImage({ rawUrl, alt, className, style, fallback = null }: Props) {
  const [src, setSrc] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setSrc(null)
    if (!rawUrl) return
    resolveProfilePictureUrl(rawUrl).then((url) => {
      if (!cancelled) setSrc(url)
    })
    return () => {
      cancelled = true
    }
  }, [rawUrl])

  if (!src) return <>{fallback}</>
  return <img src={src} alt={alt} className={className} style={style} />
}
